import { getOrders } from '@streampac.io/chef_sp_1';

export default {
	saveOrderDataInStore(that, isAuthenticated) {
		// setTimeout(() => {
		if (isAuthenticated) {
			getOrders(isAuthenticated).then(response => {
				//Return unique items
				const unique = (value, index, self) => {
					return self.indexOf(value) === index;
				};

				const returnSubscriptionsObj = response.filter(
					item =>
						item.pricePlan != null &&
						item.status == 'succeeded' &&
						Date.parse(item.payedUntill) > Date.now()
				);

				const payPerViewObj = response.filter(
					item =>
						item.pricePlan == null &&
						item.status == 'succeeded' &&
						Date.parse(item.payedUntill) > Date.now()
				);

				let getSubscriptions = returnSubscriptionsObj;
				let getPayPerView = payPerViewObj;

				let tempMediaArray = [];

				//Filter for unique items
				that.getPayPerView.forEach(element =>
					tempMediaArray.push(element.mediaId)
				);

				let getMediaIds = tempMediaArray.filter(unique);

				that.$store.commit('saveUserSubscriptions', getSubscriptions);
				that.$store.commit('saveRentedMedia', getPayPerView);
				that.$store.commit('saveRentedMediaIDs', getMediaIds);
			});
		}
		// }, 100);
	}

	// fetchMediaList(this.isAuthenticated, 'default').then(response => {
	// 	const mediaItems = response.filter(item =>
	// 		this.getMediaIds.includes(item.mediaId)
	// 	);
	// 	this.mediaItemObj = mediaItems;
	// });
};

// export default pascalTest = {
// 	data() {
// 		return {};
// 	},
// 	created() {
// 		console.log(this.$store);
// 	}
// };

// export function saveOrderDataInStore(isAuthenticated) {
// 	console.log('fires');
// 	console.log(isAuthenticated);

// 	//console.log(this.$store);

// 	// setTimeout(() => {
// 	// 	getOrders(authenticated).then(response => {
// 	// 		console.log('fires + logged in');
// 	// 		//Return unique items
// 	// 		const unique = (value, index, self) => {
// 	// 			return self.indexOf(value) === index;
// 	// 		};

// 	// 		console.log(response);

// 	// 		const returnSubscriptionsObj = response.filter(
// 	// 			item =>
// 	// 				item.pricePlan != null &&
// 	// 				item.status == 'succeeded' &&
// 	// 				Date.parse(item.payedUntill) > Date.now()
// 	// 		);

// 	// 		const payPerViewObj = response.filter(
// 	// 			item =>
// 	// 				item.pricePlan == null &&
// 	// 				item.status == 'succeeded' &&
// 	// 				Date.parse(item.payedUntill) > Date.now()
// 	// 		);

// 	// 		this.getSubscriptions = returnSubscriptionsObj;
// 	// 		this.getPayPerView = payPerViewObj;

// 	// 		let tempMediaArray = [];

// 	// 		//Filter for unique items
// 	// 		this.getPayPerView.forEach(element =>
// 	// 			tempMediaArray.push(element.mediaId)
// 	// 		);

// 	// 		this.getMediaIds = tempMediaArray.filter(unique);

// 	// 		console.log(this.getSubscriptions);
// 	// 		console.log(this.getPayPerView);
// 	// 		console.log(this.getMediaIds);
// 	// 	});
// 	// }, 50);

// 	// fetchMediaList(this.isAuthenticated, 'default').then(response => {
// 	// 	const mediaItems = response.filter(item =>
// 	// 		this.getMediaIds.includes(item.mediaId)
// 	// 	);
// 	// 	this.mediaItemObj = mediaItems;
// 	// });
// }
